import { useState } from "react";
import { IOrbProps } from "./App";
import { useApi } from './components/useApi';
import { useUserContext } from './components/useUserContext';
import { useDataContext } from './components/useDataContext';
import { useIntegration } from './components/useIntegration';
import React from "react";
import { HashRouter, Switch, Route } from 'react-router-dom';
import { ErrorBoundary } from "./components/ErrorBoundary";
import { IntegrationContext } from "./components/IntegrationContext";
import { DataContext } from "./components/DataContext";
import { OrbUserContext } from "./components/OrbUserContext";
import { CrLoadingOverlay } from './components/cr/CrLoadingOverlay';
import { AppGlobals, AppIDs } from "./AppGlobals";
import Logout from "./Logout";
import { withErrorHandling } from './components/withErrorHandling';
import { NotAuthorised, NotFound } from "./Routes";
import LoadingWhite from "./LoadingWhite";
import { Insights } from "./components/Insights";
import { StudyPlannerMenu } from "./components/StudyPlannerMenu";
import { App03StudyPlannerWelcome } from "./components/app03Workflows/App03StudyPlannerWelcome";
import StudyPlannerTasks from "./components/app03Workflows/StudyPlannerTasks";
import { MenuToggle } from "./components/MenuToggle";
import { App03Frameworks } from "./types/App03Workflow";
//import StudyPlannerTasks from "./components/app03Workflows/StudyPlannerTasks";

const StudyPlannerApp: React.FunctionComponent<IOrbProps> = (props: IOrbProps) => {

    const [lastPortfolioIdForChilds, setLastPortfolioIdForChilds] = useState(null);
    const { dataServices, errorHandling } = props;
    const apiConnected = useApi(dataServices/*, errorHandling*/);
    const uc = useUserContext(apiConnected, dataServices, errorHandling);
    const ld = useDataContext(apiConnected, dataServices, errorHandling);
    const integration = useIntegration({
        disableDirectorateManagement: false,
        disableGroupManagement: false,
        disablePartnerOrganisationManagement: false,
        disableProjectManagement: false,
        disableUserManagement: false,
        dataSourceName: ''
    });
    const routeProps = { ...props, apiConnected: apiConnected, ...uc, ...ld };

    const commonProps = {
        lastPortfolioIdForChilds: lastPortfolioIdForChilds,
        setLastPortfolioIdForChilds: setLastPortfolioIdForChilds,
        frameworkID: App03Frameworks.Kanban,
        ...routeProps,

    };


    const [isNavigationVisible, setNavigationVisible] = useState(false);

    const toggleNavigation = () => {
        setNavigationVisible(!isNavigationVisible);
    };

    if (uc.userContext.UserId === null) return (<LoadingWhite />);

    const appName = props.menuData.filter(m => m.ID === AppIDs.CORWF)[0].AppName;

    return (

        <React.Fragment>
            <ErrorBoundary>
                <IntegrationContext.Provider value={integration}>
                    <DataContext.Provider value={ld}>
                        <OrbUserContext.Provider value={uc}>
                            <div className="main">
                                <div className="blue-banner">
                                    <MenuToggle onToggleNavigation={toggleNavigation} />
                                    <div className="blue-banner-white-bold">ZedX for {AppGlobals.CustomerSectorTitle} - {appName}</div>
                                    <div className="right-aligned-text"><Logout onLogout={props.onLogout} /></div>
                                </div>
                                <div className="container">
                                    <HashRouter>
                                        <div className={`navigation ${isNavigationVisible ? 'show' : ''}`}>
                                            {!uc.userContext.UserId &&
                                                <CrLoadingOverlay isLoading={true} />
                                                ||
                                                <StudyPlannerMenu {...routeProps} onLinkClicked={toggleNavigation} />
                                            }
                                        </div>
                                        <div className="content">
                                            <Switch>
                                                <Route exact path="/a13/welcome" {...routeProps}>
                                                    <App03StudyPlannerWelcome />
                                                </Route>
                                                <Route exact path="/a13/insights" {...routeProps}>
                                                    <Insights dashboardRef='WorkflowsInsightsdashboard' />
                                                </Route>
                                                <Route path="/a13/tasks" {...routeProps}>
                                                    <StudyPlannerTasks {...commonProps} />
                                                </Route>
                                                <Route path="/not-authorised">
                                                    <NotAuthorised />
                                                </Route>
                                                <Route path="*">
                                                    <NotFound />
                                                </Route>
                                            </Switch>
                                        </div>
                                    </HashRouter>
                                </div>
                            </div>
                        </OrbUserContext.Provider>
                    </DataContext.Provider>
                </IntegrationContext.Provider>
            </ErrorBoundary>
        </React.Fragment>
    );
};

export const StudyPlannerAppWithErrorHandling = withErrorHandling(StudyPlannerApp);